export interface BaseType<N = string, V = string> {
  name: N;
  value: V;
}
export interface IKeyValue<T = any> {
  key: string;
  value: T;
}
